<template>
  <section class="ead-page">    
    <b-message v-if="erro" type="is-danger" aria-close-label="Fechar" @close="erro = ''">{{ erro }}</b-message>

    <div class="box cursos-header">
      <div>
        <p class="cursos-header__legenda">Catálogo de treinamentos</p>
        <h1 class="title is-4 mb-1">Cursos</h1>
        <p class="has-text-grey">          
        </p>
      </div>
      <router-link
        v-if="isInRole('rh-diretoria')"
        class="button is-primary"
        :to="{ name: 'ead-curso-cadastro' }"
      >
        <b-icon icon="plus" size="is-small" />
        <span>Novo curso</span>
      </router-link>
    </div>

    <div class="box cursos-card">
      <div class="cursos-toolbar">
        <div class="busca-cursos">
          <b-input
            v-model="busca"
            icon="magnify"
            :icon-right="busca ? 'close-circle' : null"
            icon-right-clickable
            placeholder="Buscar por nome ou código"
            @input="agendarBusca"
            @icon-right-click="limparBusca"
          />
        </div>
        <div class="total-cursos">
          <b-icon icon="book-open-page-variant" size="is-small" />
          <span>
            <strong>{{ dados.total || 0 }}</strong>
            {{ (dados.total || 0) === 1 ? 'curso encontrado' : 'cursos encontrados' }}
          </span>
        </div>
      </div>

      <b-table
        :data="dados.lista || []"
        :loading="loading"
        :mobile-cards="true"
        hoverable
        class="cursos-tabela"
      >
        <b-table-column field="nome" label="Curso" v-slot="p">
          <div class="curso-identificacao">
            <span class="curso-icone">
              <b-icon icon="school-outline" size="is-small" />
            </span>
            <div class="curso-dados">
              <p class="has-text-weight-semibold">{{ p.row.nome }}</p>
              <span class="curso-codigo">{{ p.row.codigo }}</span>
            </div>
          </div>
        </b-table-column>

        <b-table-column
          field="cargaHorariaMinutos"
          label="Carga horária"
          v-slot="p"
        >
          <span class="dado-com-icone">
            <b-icon icon="clock-outline" size="is-small" />
            {{ formatarDuracao(p.row.cargaHorariaMinutos) }}
          </span>
        </b-table-column>

        <b-table-column label="Características" v-slot="p">
          <div class="curso-tags">
            <b-tag v-if="p.row.obrigatorio" rounded type="is-warning is-light">
              Obrigatório
            </b-tag>
            <b-tag
              v-if="p.row.possuiAvaliacaoFinal"
              rounded
              type="is-info is-light"
            >
              Com avaliação
            </b-tag>
            <span
              v-if="!p.row.obrigatorio && !p.row.possuiAvaliacaoFinal"
              class="has-text-grey-light"
            >
              —
            </span>
          </div>
        </b-table-column>

        <b-table-column field="ativo" label="Status" centered v-slot="p">
          <b-tag rounded :type="p.row.ativo ? 'is-success' : 'is-light'">
            {{ p.row.ativo ? 'Ativo' : 'Inativo' }}
          </b-tag>
        </b-table-column>

        <b-table-column v-slot="p" label="Ações" centered>
          <div class="acoes-curso">
            <router-link
              v-if="isInRole('rh-diretoria')"
              class="button is-small is-light"
              title="Editar curso"
              :to="{ name: 'ead-curso-cadastro', params: { id: p.row.id } }"
            >
              <b-icon icon="pencil-outline" size="is-small" />
              <span>Editar</span>
            </router-link>
            <router-link
              class="button is-small is-primary"
              title="Gerenciar conteúdo"
              :to="{ name: 'ead-curso-conteudo', params: { id: p.row.id } }"
            >
              <b-icon icon="book-open-page-variant" size="is-small" />
              <span>Conteúdo</span>
            </router-link>
          </div>
        </b-table-column>

        <template #empty>
          <div v-if="!loading" class="estado-vazio">
            <span class="estado-vazio__icone">
              <b-icon icon="book-search-outline" size="is-medium" />
            </span>
            <p class="has-text-weight-semibold">
              {{ busca ? 'Nenhum curso encontrado' : 'Nenhum curso cadastrado' }}
            </p>
            <p class="has-text-grey is-size-7">
              {{
                busca
                  ? 'Tente buscar usando outro nome ou código.'
                  : 'Cadastre o primeiro curso para começar a organizar o conteúdo.'
              }}
            </p>
          </div>
        </template>
      </b-table>

      <div v-if="dados.pageCount > 1" class="paginacao-cursos">
        <b-pagination
          :total="dados.total"
          :current.sync="pagina"
          :per-page="porPagina"
          order="is-centered"
          @change="carregar"
        />
      </div>
    </div>
  </section>
</template>

<script>
import http from '@/http'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'EadCursos',
  data: () => ({
    dados: { lista: [], total: 0, pageCount: 0 },
    busca: '',
    loading: false,
    erro: '',
    pagina: 1,
    porPagina: 20,
    timerBusca: null,
  }),
  computed: {
    ...mapState(['unidadeId']),
    ...mapGetters(['isInRole']),
  },
  watch: {
    unidadeId() {
      this.pagina = 1
      this.carregar()
    },
  },
  mounted() {
    this.carregar()
  },
  beforeDestroy() {
    clearTimeout(this.timerBusca)
  },
  methods: {
    carregar() {
      this.loading = true
      this.erro = ''
      http
        .get('/api/manutencao/ead-cursos', {
          params: {
            unidadeId: this.unidadeId,
            procurar: this.busca,
            page: this.pagina,
            perPage: this.porPagina,
          },
        })
        .then((r) => (this.dados = r.data))
        .catch((e) => {
          this.dados = { lista: [], total: 0, pageCount: 0 }
          this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível carregar os cursos.'
        })
        .finally(() => (this.loading = false))
    },
    agendarBusca() {
      clearTimeout(this.timerBusca)
      this.timerBusca = setTimeout(() => {
        this.pagina = 1
        this.carregar()
      }, 350)
    },
    limparBusca() {
      clearTimeout(this.timerBusca)
      this.busca = ''
      this.pagina = 1
      this.carregar()
    },
    formatarDuracao(valor) {
      const minutos = Number(valor) || 0
      if (minutos < 60) return `${minutos} min`
      const horas = Math.floor(minutos / 60)
      const restante = minutos % 60
      return restante ? `${horas}h ${restante}min` : `${horas}h`
    },
  },
}
</script>

<style scoped>
.ead-page {
  min-height: 100%;
}

.cursos-header,
.cursos-toolbar,
.total-cursos,
.curso-identificacao,
.dado-com-icone,
.acoes-curso {
  align-items: center;
  display: flex;
}

.cursos-header {
  border-left: 4px solid #00b89c;
  gap: 1.5rem;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.cursos-header__legenda {
  color: #7a7a7a;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
}

.cursos-card {
  border: 1px solid #ededed;
  box-shadow: 0 2px 8px rgba(10, 10, 10, 0.05);
  padding: 0;
  overflow: hidden;
}

.cursos-toolbar {
  background: #fafafa;
  border-bottom: 1px solid #ededed;
  gap: 1rem;
  justify-content: space-between;
  padding: 1rem 1.25rem;
}

.busca-cursos {
  max-width: 480px;
  width: 100%;
}

.total-cursos,
.dado-com-icone {
  color: #7a7a7a;
  gap: 0.4rem;
}

.total-cursos {
  flex: 0 0 auto;
  font-size: 0.85rem;
}

.cursos-tabela {
  padding: 0.5rem 1rem 1rem;
}

.curso-identificacao {
  gap: 0.75rem;
  min-width: 220px;
}

.curso-icone,
.estado-vazio__icone {
  align-items: center;
  background: rgba(0, 184, 156, 0.1);
  border-radius: 50%;
  color: #008f79;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
}

.curso-icone {
  height: 2.25rem;
  width: 2.25rem;
}

.curso-dados {
  min-width: 0;
}

.curso-codigo {
  color: #7a7a7a;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
}

.dado-com-icone {
  white-space: nowrap;
}

.curso-tags,
.acoes-curso {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.acoes-curso {
  justify-content: center;
}

.estado-vazio {
  align-items: center;
  color: #7a7a7a;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
}

.estado-vazio__icone {
  height: 3.5rem;
  margin-bottom: 0.75rem;
  width: 3.5rem;
}

.paginacao-cursos {
  border-top: 1px solid #ededed;
  padding: 1rem;
}

@media screen and (max-width: 768px) {
  .cursos-header,
  .cursos-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .cursos-header .button,
  .busca-cursos {
    max-width: none;
    width: 100%;
  }

  .total-cursos {
    justify-content: center;
  }

  .acoes-curso {
    justify-content: flex-start;
  }

  .acoes-curso .button {
    flex: 1;
  }
}
</style>
